import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'src/app/shared/models/model/concretes/shared/subcription.model';
import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AppResource } from 'src/app/app.resource';
import { RouterModule } from '@angular/router';
import {
  Stepper,
  StepShow,
  Subtitle,
  Title
} from 'src/app/shared/models/model/concretes/components/stepper.model';
import { Step } from 'src/app/shared/models/model/concretes/components/step.model';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  imports: [CommonModule, DialogModule, RouterModule],
  standalone: true
})
export class ProgressCircleComponent extends BaseComponent implements OnInit {
  @Input() progress: number = 0; // Pourcentage (de 0 à 100)
  @Input() size: number = 144.51;
  @Input() sizeWH: number = 52.26;
  @Input() coordinates: number = 26.13;
  @Input() radius: number = 23;
  @Input() step: number = 1;
  @Input() maxStep: number = 3;

  displayModal: boolean = false;
  steppers!: StepShow;
  stepper: Stepper = new Stepper([]);

  constructor(
    resources: AppResource,
    private el: ElementRef,
    private renderer: Renderer2,
    private sharedDataService: SharedDataService
  ) {
    super(resources);

    effect(() => {
      const subSignal = this.sharedDataService.getSubscription();
      const index = this.sharedDataService.getStepIndex();

      if (subSignal != null && index() != -1) {
        this.updateStepper(subSignal());
      }
    });
  }

  override ngOnInit() {
    this.updateProgress();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['progress']) {
      this.updateProgress();
    }
  }

  //#region Public Method
  showDialog() {
    this.displayModal = true;
  }
  //#endregion

  //#region Private Method
  private updateProgress() {
    const circle = this.el.nativeElement.querySelector('svg circle:nth-child(2)');
    if (circle) {
      const dashoffset = this.size - (this.size * this.progress) / 100;
      this.renderer.setStyle(circle, 'stroke-dashoffset', dashoffset);
    }
  }

  private updateStepper(subscription: Subscription | null) {
    this.stepper.steps = [];
    subscription?.groupSteps.map(groupStep => {
      // Créer un nouveau Map pour chaque groupStep
      const stepMap = new Map<string, Step[]>();

      // Parcourir les étapes de ce groupStep
      groupStep.steps.map(step => {
        if (stepMap.has(step.layoutInfo.title)) {
          stepMap.get(step.layoutInfo.title)?.push(step);
        } else {
          stepMap.set(step.layoutInfo.title, [step]);
        }
      });

      // Convertir le Map en tableau pour le groupStep en cours
      const groupedSteps = Array.from(stepMap, ([libelle, steps]) => ({ libelle, steps }));
      this.stepper.steps.push(
        new StepShow(
          this.getGroupStepIsVisible(groupedSteps),
          groupedSteps.map(groupedStep => {
            return new Title(
              groupedStep.libelle,
              groupedStep.steps.map(step => {
                return new Subtitle(
                  step.layoutInfo.subtitle,
                  ['subscription', step.url],
                  step.isCompleted,
                  step.isActive,
                  true
                );
              }),
              this.getStepIsActive(groupedStep.steps)
            );
          })
        )
      );
    });
  }

  private getGroupStepIsVisible(groupedSteps: any[]): boolean {
    return groupedSteps.some(groupedStep => {
      const subtitles = groupedStep.steps.map((step: Step) => {
        return new Subtitle(
          step.layoutInfo.subtitle,
          ['subscription', step.url],
          step.isCompleted,
          step.isActive,
          true
        );
      });
      // Vérifie si un des sous-titres est actif ou complété
      return subtitles.some((subtitle: Subtitle) => subtitle.isActive);
    });
  }

  private getStepIsActive(steps: Step[]): boolean {
    const subtitles = steps.map((step: Step) => {
      return new Subtitle(
        step.layoutInfo.subtitle,
        ['subscription', step.url],
        step.isCompleted,
        step.isActive,
        true
      );
    });
    // Vérifie si un des sous-titres est actif ou complété
    return subtitles.some((subtitle: Subtitle) => subtitle.isValid || subtitle.isActive);
  }
  //#endregion
}
